<template>
  <section id="donate">
    <div class="container">
      <h2 class="text-center">Donate Now</h2>
      <div class="box">
        <p>You can make a <strong>one-time gift</strong> to Pencils for Kids, Inc. or <strong>sign up for a sustaining donation</strong>, which supports our missions year-round. All donations are tax-deductible.</p>
        <h5>Donation Type &amp; Amount</h5>
        <div class="form-group">
          <label>
            <input type="radio" v-model="frequency" value="oneTime"> One-Time Donation
          </label>
          <span>&mdash; or &mdash;</span>
          <label>
            <input type="radio" v-model="frequency" value="sustaining"> Sustaining Donation
          </label>
        </div>
      </div>
      <div class="donations">
        <div v-if="frequency === 'oneTime'">
          <h5>Each backpack and uniform costs $60. How many backpacks would you like?</h5>
          <form action="https://www.paypal.com/donate" method="post" target="_top">
            <input type="hidden" name="cmd" value="_s-xclick">
            <input type="hidden" name="hosted_button_id" value="PNN2WWZHQE7XN">
            <input type="submit" value="1 Backpack - Donate $60" class="btn btn-primary btn-block" name="submit" alt="PayPal - The safer, easier way to pay online!">
            <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
          </form>
          <form action="https://www.paypal.com/donate" method="post" target="_top">
            <input type="hidden" name="cmd" value="_s-xclick">
            <input type="hidden" name="hosted_button_id" value="AM2SQ496NPWUY">
            <input type="submit" value="2 Backpacks - Donate $120" class="btn btn-primary btn-block" name="submit" alt="PayPal - The safer, easier way to pay online!">
            <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
          </form>
          <form action="https://www.paypal.com/donate" method="post" target="_top">
            <input type="hidden" name="cmd" value="_s-xclick">
            <input type="hidden" name="hosted_button_id" value="TSPM7KZWS7MJG">
            <input type="submit" value="4 Backpacks - Donate $240" class="btn btn-primary btn-block" name="submit" alt="PayPal - The safer, easier way to pay online!">
            <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
          </form>
          <form action="https://www.paypal.com/donate" method="post" target="_top">
            <input type="hidden" name="cmd" value="_s-xclick">
            <input type="hidden" name="hosted_button_id" value="KWVEDYHM2PRRE">
            <input type="submit" value="6 Backpacks - Donate $360" class="btn btn-primary btn-block" name="submit" alt="PayPal - The safer, easier way to pay online!">
            <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
          </form>
          <form action="https://www.paypal.com/donate" method="post" target="_top">
            <input type="hidden" name="cmd" value="_s-xclick">
            <input type="hidden" name="hosted_button_id" value="E4ZBC2DBU9LLC">
            <input type="submit" value="8 Backpacks - Donate $480" class="btn btn-primary btn-block" name="submit" alt="PayPal - The safer, easier way to pay online!">
            <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
          </form>
          <form action="https://www.paypal.com/donate" method="post" target="_top">
            <input type="hidden" name="cmd" value="_s-xclick">
            <input type="hidden" name="hosted_button_id" value="U37NLUN458A9C">
            <input type="submit" value="10 Backpacks - Donate $600" class="btn btn-primary btn-block" name="submit" alt="PayPal - The safer, easier way to pay online!">
            <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
          </form>
          <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
            <input type="hidden" name="cmd" value="_s-xclick">
            <input type="hidden" name="hosted_button_id" value="BNPK3YXJUXAFL">
            <input type="submit" value="Donate Other" class="btn btn-primary btn-block" name="submit" alt="PayPal - The safer, easier way to pay online!">
            <input type="hidden" name="amount" value="15">
            <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
          </form>
          <p>You also may support school supplies and uniforms for an entire school. Please contact us for details.</p>
          <p>Here's what you are giving --</p>
          <p>Each backpack for K-2nd grade contains:</p>
          <ul>
            <li>1 school uniform</li>
            <li>1 dozen pencils</li>
            <li>12 notebooks</li>
            <li>1 box of crayons</li>
            <li>1 package of markers</li>
            <li>1 package of colored pencils</li>
            <li>2 pads of coloring paper</li>
            <li>1 pencil bag</li>
            <li>2 erasers</li>
            <li>1 pencil sharpener</li>
            <li>1 ruler</li>
            <li>1 journal</li>
            <li>1 toothbrush</li>
          </ul>
          <p>Each backpack for 3rd-College contains:</p>
          <ul>
            <li>1 school uniform</li>
            <li>1 dozen pencils</li>
            <li>12 notebooks</li>
            <li>1 package of ballpoint pens</li>
            <li>1 package of markers</li>
            <li>1 package of colored pencils</li>
            <li>2 pads of coloring paper</li>
            <li>1 pencil bag</li>
            <li>2 erasers</li>
            <li>1 pencil sharpener</li>
            <li>1 ruler</li>
            <li>1 journal</li>
            <li>1 toothbrush</li>
          </ul>
        </div>
        <div v-if="frequency === 'sustaining'">
          <h5>Yes, I'd like support Pencils For Kids, Inc. year-round with easy automatic payments, in this amount each month:</h5>
          <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
            <input type="hidden" name="cmd" value="_xclick-subscriptions">
            <input type="hidden" name="business" value="7MP7BPZLRAR2W">
            <input type="hidden" name="lc" value="US">
            <input type="hidden" name="item_name" value="Sustaining Donation">
            <input type="hidden" name="no_note" value="1">
            <input type="hidden" name="no_shipping" value="2">
            <input type="hidden" name="src" value="1">
            <input type="hidden" name="srt" value="0">
            <input type="hidden" name="p3" value="1">
            <input type="hidden" name="t3" value="M">
            <input type="hidden" name="a3" value="10">
            <input type="hidden" name="currency_code" value="USD">
            <input type="hidden" name="bn" value="PP-SubscriptionsBF:btn_subscribeCC_LG.gif:NonHosted">
            <input class="btn btn-block btn-primary" type="submit" value="$10" name="submit" alt="PayPal - The safer, easier way to pay online!">
            <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
          </form>
          <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
            <input type="hidden" name="cmd" value="_xclick-subscriptions">
            <input type="hidden" name="business" value="7MP7BPZLRAR2W">
            <input type="hidden" name="lc" value="US">
            <input type="hidden" name="item_name" value="Sustaining Donation">
            <input type="hidden" name="no_note" value="1">
            <input type="hidden" name="no_shipping" value="2">
            <input type="hidden" name="src" value="1">
            <input type="hidden" name="srt" value="0">
            <input type="hidden" name="p3" value="1">
            <input type="hidden" name="t3" value="M">
            <input type="hidden" name="a3" value="15">
            <input type="hidden" name="currency_code" value="USD">
            <input type="hidden" name="bn" value="PP-SubscriptionsBF:btn_subscribeCC_LG.gif:NonHosted">
            <input class="btn btn-block btn-primary" type="submit" value="$15" name="submit" alt="PayPal - The safer, easier way to pay online!">
            <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
          </form>
          <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
            <input type="hidden" name="cmd" value="_xclick-subscriptions">
            <input type="hidden" name="business" value="7MP7BPZLRAR2W">
            <input type="hidden" name="lc" value="US">
            <input type="hidden" name="item_name" value="Sustaining Donation">
            <input type="hidden" name="no_note" value="1">
            <input type="hidden" name="no_shipping" value="2">
            <input type="hidden" name="src" value="1">
            <input type="hidden" name="srt" value="0">
            <input type="hidden" name="p3" value="1">
            <input type="hidden" name="t3" value="M">
            <input type="hidden" name="a3" value="20">
            <input type="hidden" name="currency_code" value="USD">
            <input type="hidden" name="bn" value="PP-SubscriptionsBF:btn_subscribeCC_LG.gif:NonHosted">
            <input class="btn btn-block btn-primary" type="submit" value="$20" name="submit" alt="PayPal - The safer, easier way to pay online!">
            <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
          </form>
          <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
            <input type="hidden" name="cmd" value="_xclick-subscriptions">
            <input type="hidden" name="business" value="7MP7BPZLRAR2W">
            <input type="hidden" name="lc" value="US">
            <input type="hidden" name="item_name" value="Sustaining Donation">
            <input type="hidden" name="no_note" value="1">
            <input type="hidden" name="no_shipping" value="2">
            <input type="hidden" name="src" value="1">
            <input type="hidden" name="srt" value="0">
            <input type="hidden" name="p3" value="1">
            <input type="hidden" name="t3" value="M">
            <input type="hidden" name="a3" value="25">
            <input type="hidden" name="currency_code" value="USD">
            <input type="hidden" name="bn" value="PP-SubscriptionsBF:btn_subscribeCC_LG.gif:NonHosted">
            <input class="btn btn-block btn-primary" type="submit" value="$25" name="submit" alt="PayPal - The safer, easier way to pay online!">
            <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
          </form>
          <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
            <input type="hidden" name="cmd" value="_xclick-subscriptions">
            <input type="hidden" name="business" value="7MP7BPZLRAR2W">
            <input type="hidden" name="lc" value="US">
            <input type="hidden" name="item_name" value="Sustaining Donation">
            <input type="hidden" name="no_note" value="1">
            <input type="hidden" name="no_shipping" value="2">
            <input type="hidden" name="src" value="1">
            <input type="hidden" name="srt" value="0">
            <input type="hidden" name="p3" value="1">
            <input type="hidden" name="t3" value="M">
            <input type="hidden" name="a3" value="30">
            <input type="hidden" name="currency_code" value="USD">
            <input type="hidden" name="bn" value="PP-SubscriptionsBF:btn_subscribeCC_LG.gif:NonHosted">
            <input class="btn btn-block btn-primary" type="submit" value="$30" name="submit" alt="PayPal - The safer, easier way to pay online!">
            <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
          </form>
          <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
            <input type="hidden" name="cmd" value="_xclick-subscriptions">
            <input type="hidden" name="business" value="7MP7BPZLRAR2W">
            <input type="hidden" name="lc" value="US">
            <input type="hidden" name="item_name" value="Sustaining Donation">
            <input type="hidden" name="no_note" value="1">
            <input type="hidden" name="no_shipping" value="2">
            <input type="hidden" name="src" value="1">
            <input type="hidden" name="srt" value="0">
            <input type="hidden" name="p3" value="1">
            <input type="hidden" name="t3" value="M">
            <div class="input-group">
              <span class="input-group-addon">$</span>
              <input type="number" name="a3" value="5" required class="form-control" step="any" size="">
              <span class="input-group-addon">/ mo</span>
            </div>
            <input type="hidden" name="currency_code" value="USD">
            <input type="hidden" name="bn" value="PP-SubscriptionsBF:btn_subscribeCC_LG.gif:NonHosted">
            <input class="btn btn-block btn-primary" type="submit" value="Donate Other" name="submit" alt="PayPal - The safer, easier way to pay online!">
            <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
          </form>
          <p>Pencils For Kids, Inc., will never share our contributors' financial information, phone numbers or emails with anyone. We respect your privacy and will only contact you if necessary regarding your donation.</p>
          <p>Pencils For Kids, Inc., is a non-profit corporation with 501c3 tax-exempt status.</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'donate',
  data () {
    return {
      frequency: 'oneTime'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/styles/vars';

section {
  padding: 80px 0;
}

.donations {
  max-width: 720px;
  margin: 1rem auto 0;
  h5 {
    margin-bottom: 2rem;
  }
}

table {
  width: 100%;
}

.box {
  padding: 2rem;
  border: none;
  background-color: $gold;
  max-width: 720px;
  margin: 2rem auto;
}

.form-control {
  background: white;
}

.input-group {
  display: flex;
  max-width: 260px;
  margin: 0 auto;
  text-align: center;
}

.btn-primary {
  font-family: $sans;
  max-width: 260px;
  margin: auto;
}

.form-group {
  display: flex;
  justify-content: space-between;
  label {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// Donate.vue?684bc24a